import React from "react";
import Navbar from "./Navbar";
import Hero from "./Hero";
import JobRoles from "./JobRoles";
import HowItWorks from "./HowItWorks";
import Animation from "./Animation";
import Footer from "./Footer";
import TrustCard from "./TrustCard";

function Landing() {
    return (
        <div>
            {/* <Navbar /> */}
            <Hero />
            <JobRoles />
            <TrustCard/>
            <HowItWorks />
            <Animation />
            {/* <Footer /> */}
        </div>


    );
}

export default Landing;